import React from 'react';
import { useSecondScreenData } from '../../../contexts/SecondScreenContext';
import type { WidgetProps } from '../../../types/second-screen.types';

const AssumptionWallWidget: React.FC<WidgetProps> = () => {
  const { state, theme } = useSecondScreenData();
  const isDark = theme === 'dark';

  const assumptions = state?.requirements?.assumptions ?? [];

  if (!state) return null;

  if (assumptions.length === 0) {
    return (
      <div className={`flex items-center justify-center h-full text-sm ${isDark ? 'text-white/30' : 'text-slate-400'}`}>
        No assumptions surfaced yet
      </div>
    );
  }

  // Color cycle for assumption cards (all untested since we don't track validation)
  const cardColors = [
    isDark ? 'bg-white/[0.04] border-white/10' : 'bg-slate-50 border-slate-200',
    isDark ? 'bg-primary/[0.06] border-primary/20' : 'bg-primary/5 border-primary/15',
    isDark ? 'bg-amber-500/[0.06] border-amber-500/20' : 'bg-amber-50 border-amber-200',
  ];

  return (
    <div className="grid grid-cols-2 gap-2 h-full p-3 overflow-y-auto content-start">
      {assumptions.map((assumption, i) => (
        <div
          key={assumption}
          className={`p-2.5 rounded-lg border ${cardColors[i % cardColors.length]} transition-all duration-500`}
        >
          <span className={`text-xs font-bold uppercase tracking-wider ${
            isDark ? 'text-white/30' : 'text-slate-400'
          }`}>
            #{i + 1}
          </span>
          <p className={`text-xs mt-1 leading-relaxed ${isDark ? 'text-white/70' : 'text-slate-600'}`}>
            {assumption}
          </p>
        </div>
      ))}
    </div>
  );
};

export default AssumptionWallWidget;
